export default __webpack_public_path__ + "media/images/features/hida/grid-4-30e946e3eaddb1217aa4bfb7d993750b.png";